
const imageUrl = (title) => {
  return `/imgs/solution/transport/${title}.png`;
};

const data = {
  banner: {
    title: '网络货运平台解决方案',
    description: '平台搭建快速交付，资质代申请，解决进项获取难题，降低税负成本。',
    bg: imageUrl('banner')
  },
  method: [
    {
      img: imageUrl('method1'),
      title: '平台搭建全流程交付'
    },
    {
      img: imageUrl('method2'),
      title: '全新政策解读，资质代申报'
    },
    {
      img: imageUrl('method3'),
      title: '参与业务流程重塑、组织机构改革'
    },
    {
      img: imageUrl('method4'),
      title: '提供平台运营推广方案'
    },
    {
      img: imageUrl('method5'),
      title: '财税筹划，降低税负成本'
    },
  ],
  advantage: [
    {
      img: imageUrl('advantage1'),
      title: '平台交付优势',
      description: '团队成员从事供应链、物流、财税信息化行业超过15年，积累了丰富的产研资源，能对各级政府的最新文件实时充分解读，能实现平台搭建快速交付。'
    },
    {
      img: imageUrl('advantage2'),
      title: '平台功能优势',
      description: '平台功能完全涵盖国家最新规定，并结合行业经验，在此基础上增加平台运营管理、电子合同、大数据分析等重要功能。'
    },
    {
      img: imageUrl('advantage3'),
      title: '运营优势',
      description: '基于成熟的运营案例，可协助客户品牌推广，提供对外运营策略指导，降低运营成本，实现快速盈利。'
    },
    {
      img: imageUrl('advantage4'),
      title: '服务优势',
      description: '提供一揽子解决方案，主要包括：资质代申报全程支持，重塑业务流程及组织架构，完成知识转移。'
    },
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Solution/config/transport.js